module.exports = __webpack_public_path__ + "static/media/waves_3.9012357d.jpg";